import React from 'react';

function fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}

class AudioTimer extends React.Component {
  constructor(props) {
    super(props);
    console.log("AudioTimer constructor");
    this.state = {
      timer: '',
      //clickArea: props.clickArea,
      
      //audioRecordstatus: props.audioRecordstatus,
      //force_timerCount: props.force_timerCount
    };
    
    this.audioRecordstatus = props.audioRecordstatus || null;
    this.force_timerCount = props.force_timerCount || null;
    
    this.delayTime = props.delayTime || null;
    this.audioTimer_handler = props.audioTimer_handler;
    this.seconds_per_slide = props.seconds_per_slide;
    this.required_slide_count = props.required_slide_count;
    if (this.delayTime !== null) {
      this.required_slide_count = this.props.required_slide_count + 1;
    }
    this.timerCount = 0;

    this.start_interval_time = 0;
    this.start_timer_count = 0;
    this.interval_ms = 1000;
    this.delay_constant = 0; // for some reason the audio ends up 19.92s instead of 20s

    
    
    this.interval = null; // for setInterval
    
    /*
    let timePrint = fmtMSS(Math.floor(this.timerCount));
    if (this.delayTime) {
      this.state.timer = 'Cover Slide / Introduction - '+timePrint;
    } else {
      this.state.timer = 'Slide 1 - '+timePrint;
    }
    */
  }
  
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  
  componentDidUpdate() {
    // we only want to do things here if we got changes from props
    /*
    if (this.props.force_timerCount === this.state.force_timerCount && this.props.clickArea === this.state.clickArea) {
      return;
    }
    */
    // we only want to do things here if we got changes from props
    //if (this.props.force_timerCount === this.state.force_timerCount && this.props.audioRecordstatus === this.state.audioRecordstatus) {
      //return;
    //}
    if (this.props.force_timerCount === this.force_timerCount && this.props.audioRecordstatus === this.audioRecordstatus) {
      return;
    }

    if (this.delayTime !== null) {
      this.required_slide_count = this.props.required_slide_count + 1;
    }
    
    this.force_timerCount = this.props.force_timerCount;
    //let clickArea = this.props.clickArea;
    this.audioRecordstatus = this.props.audioRecordstatus;
    
    console.log("AudioTimer componentDidUpdate some props",this.force_timerCount,this.audioRecordstatus,this.timerCount);
    
    //if (this.force_timerCount !== null) {
      //clearInterval(this.interval);
      //this.timerCount = this.force_timerCount;
    //}
    
    clearInterval(this.interval);
    if (this.force_timerCount !== null) {
      this.timerCount = this.force_timerCount * 1000;
      this.start_timer_count = this.force_timerCount * 1000;
    }

    //this.force_timerCount = null;
    
    /*
    if (!audioRecordstatus) {
      this.setState({
        timer: 'Slide 1',
        force_timerCount, // this is a one-time-trigger
        audioRecordstatus
      });
      return;
    }
    */

    //console.log("AudioTimer componentDidUpdate some props",force_timerCount,clickArea);
    //console.log("AudioTimer componentDidUpdate some props",force_timerCount,audioRecordstatus);

    //let new_state = {...this.state};

    //new_state.force_timerCount = null;
    //new_state.audioRecordstatus = audioRecordstatus;
    
    /*
    this.setState({
      force_timerCount: null, // this is a one-time-trigger
      audioRecordstatus
      //clickArea
    });
    */
    
    let timePrint = '';

    /*
    if (this.audioRecordstatus === null) {
      // start/restart
      clearInterval(this.interval);
      timePrint = fmtMSS(Math.floor(this.timerCount / 1000));
      let tmp_slide_number = Math.floor(((this.timerCount / 1000) - this.delayTime) / this.seconds_per_slide) + 1;

      if (this.delayTime !== null && (this.timerCount / 1000) <= this.delayTime) {
        this.setState({timer:'Cover Slide / Introduction'});
      } else {
        this.setState({timer:'Slide '+tmp_slide_number+' - '+timePrint});
      }
      
      //new_state.timer = 'Finished - Slide '+tmp_slide_number;

      this.audioTimer_handler(this.timerCount);

      return;      
    }
    */

    if (this.audioRecordstatus === 'playing') {
      // update quickly once
      timePrint = fmtMSS(Math.floor(this.timerCount / 1000));
      //let tmp_slide_number = Math.floor(this.timerCount / this.seconds_per_slide) + 1;
      let tmp_slide_number = Math.floor(((this.timerCount / 1000) - this.delayTime) / this.seconds_per_slide) + 1;
      
      if (tmp_slide_number > this.required_slide_count) {
        this.setState({timer:''});
      } else {
        if (this.delayTime && (this.timerCount / 1000) <= this.delayTime) {
          this.setState({timer:'Playing - Cover Slide / Introduction'});
        } else {
          this.setState({timer:'Playing - Slide '+tmp_slide_number+' - '+timePrint});
        }
      }
      /*
        if (this.include_cover_image) {
          if (tmp_slide_number === 1) {
            this.setState({timer:'Playing - Cover Slide / Introduction'});
          } else {
            this.setState({timer:'Playing - Slide '+(tmp_slide_number+1)+' - '+timePrint});
          }
        } else {
          this.setState({timer:'Playing - Slide '+tmp_slide_number+' - '+timePrint});
        }
      }
      */
      
      this.audioTimer_handler(this.timerCount);
      
      // set start_interval_time right before setInterval
      this.start_interval_time = new Date();
      
      this.interval = setInterval(() => {
        this.timerCount = this.timerCount + this.interval_ms;
        //let current = new Date();
        //this.timerCount = this.start_timer_count + this.delay_constant + (current - this.start_interval_time);

        timePrint = fmtMSS(Math.floor(this.timerCount / 1000));
        let tmp_slide_number = Math.floor(((this.timerCount / 1000) - this.delayTime) / this.seconds_per_slide) + 1;

        if (tmp_slide_number > this.required_slide_count) {
          this.setState({timer:''});
        } else {
          if (this.delayTime && (this.timerCount / 1000) <= this.delayTime) {
            this.setState({timer:'Playing - Cover Slide / Introduction'});
          } else {
            this.setState({timer:'Playing - Slide '+tmp_slide_number+' - '+timePrint});
          }
        }

        //console.log("AudioTimer Interval",timerCount);
        this.audioTimer_handler(this.timerCount);
      }, this.interval_ms); 
      
      return;
    }

    if (this.audioRecordstatus === 'playing_paused') {
      clearInterval(this.interval);
      
      timePrint = fmtMSS(Math.floor(this.timerCount / 1000));
      //let tmp_slide_number = Math.floor(this.timerCount / this.seconds_per_slide) + 1;
      let tmp_slide_number = Math.floor(((this.timerCount / 1000) - this.delayTime) / this.seconds_per_slide) + 1;

      if (this.delayTime && (this.timerCount / 1000) <= this.delayTime) {
        this.setState({timer:'Playing Paused - Cover Slide / Introduction'});
      } else {
        this.setState({timer:'Playing Paused - Slide '+tmp_slide_number+' - '+timePrint});
      }
      /*
      if (this.include_cover_image) {
        if (tmp_slide_number === 1) {
          this.setState({timer:'Playing Paused - Cover Slide / Introduction'});
        } else {
          this.setState({timer:'Playing Paused - Slide '+(tmp_slide_number+1)+' - '+timePrint});
        }
      } else {
        this.setState({timer:'Playing Paused - Slide '+tmp_slide_number+' - '+timePrint});
      }
      */
      
      
      //this.setState({timer:'Playing Paused - Slide '+tmp_slide_number+' - '+timePrint});
      
      this.audioTimer_handler(this.timerCount);

      return;
    }
    
    
    if (this.audioRecordstatus === 'recording') {
      // update quickly once
      timePrint = fmtMSS(Math.floor(this.timerCount / 1000));
      let tmp_slide_number = Math.floor((this.timerCount / 1000) / this.seconds_per_slide) + 1;
      
      if (tmp_slide_number > this.required_slide_count) {
        this.setState({timer:''});
      } else {
        this.setState({timer:'Recording - Slide '+tmp_slide_number+' - '+timePrint});
      }
      
      this.audioTimer_handler(this.timerCount);
      
      // set start_interval_time right before setInterval
      this.start_interval_time = new Date();
      
      this.interval = setInterval(() => {
        this.timerCount = this.timerCount + this.interval_ms;
        //let current = new Date();
        //this.timerCount = this.start_timer_count + this.delay_constant + (current - this.start_interval_time);
        
        timePrint = fmtMSS(Math.floor(this.timerCount / 1000));
        let tmp_slide_number = Math.floor((this.timerCount / 1000) / this.seconds_per_slide) + 1;
        if (tmp_slide_number > this.required_slide_count) {
          this.setState({timer:''});
        } else {
          this.setState({timer:'Recording - Slide '+tmp_slide_number+' - '+timePrint});
        }
        //console.log("AudioTimer Interval",timerCount);
        this.audioTimer_handler(this.timerCount);
      }, this.interval_ms); 
      
      return;
    }
    
    if (this.audioRecordstatus === 'recording_paused') {
      clearInterval(this.interval);
      
      timePrint = fmtMSS(Math.floor(this.timerCount / 1000));
      let tmp_slide_number = Math.floor((this.timerCount / 1000) / this.seconds_per_slide) + 1;
      
      this.setState({timer:'Recording Paused - Slide '+tmp_slide_number+' - '+timePrint});
      
      this.audioTimer_handler(this.timerCount);

      return;
    }
    



    if (this.audioRecordstatus === 'finished') {
      // done recording something
      clearInterval(this.interval);
      timePrint = fmtMSS(Math.floor(this.timerCount));
      let tmp_slide_number = Math.floor(this.timerCount / this.seconds_per_slide) + 1;
      
      this.setState({timer:'Finished Recording - Ready to Save'});
      
      this.audioTimer_handler(this.timerCount);

      return;
    }

    // should never get here?
    //this.setState({timer:''});
    
    
    /*
    if (clickArea) {

      if (clickArea === 'recording') {
        // update quickly once
        timePrint = fmtMSS(Math.floor(this.timerCount));
        let tmp_slide_number = Math.floor(this.timerCount / this.seconds_per_slide) + 1;
        if (tmp_slide_number > this.required_slide_count) {
          this.setState({timer:'Final Remarks - '+timePrint});
        } else {
          this.setState({timer:'Recording - Slide '+tmp_slide_number+' - '+timePrint});
        }
        this.audioTimer_handler(this.timerCount);
        
        this.interval = setInterval(() => {
          this.timerCount = this.timerCount + (this.interval_ms / 1000);
          timePrint = fmtMSS(Math.floor(this.timerCount));
          let tmp_slide_number = Math.floor(this.timerCount / this.seconds_per_slide) + 1;
          if (tmp_slide_number > this.required_slide_count) {
            this.setState({timer:'Final Remarks - '+timePrint});
          } else {
            this.setState({timer:'Recording - Slide '+tmp_slide_number+' - '+timePrint});
          }
          //console.log("AudioTimer Interval",timerCount);
          this.audioTimer_handler(this.timerCount);
        }, this.interval_ms); 

      } else if (clickArea === 'paused') {
        // really we are not recording, between slides
        clearInterval(this.interval);
        let tmp_slide_number = Math.floor(this.timerCount / this.seconds_per_slide) + 1;
        this.timerCount = this.timerCount - (this.timerCount % this.seconds_per_slide);
        timePrint = fmtMSS(Math.floor(this.timerCount));
        this.setState({timer:'Slide '+tmp_slide_number});
        this.audioTimer_handler(this.timerCount);
      } else if (clickArea === 'inactive') {
        // all 20 slides done
        clearInterval(this.interval);
        this.setState({timer:'Finished'});
        this.timerCount = 0;
      }
    } else {
      // restart
      this.setState({ timer: 'Slide 1' });
    }
    */
    
    // default don't show
    this.setState({ timer: '' });
  }
  
  render() {
    return <h2 style={{textAlign: 'center', color: 'red'}}>{this.state.timer}</h2>;
  }
}

export default AudioTimer;
